import React, {useEffect, useState} from 'react';
import {Icon} from '@iconify/react';
import {HexColorPicker} from 'react-colorful';
import {useDebouncedCallback} from 'use-debounce';
import Dropdown from '../../../../dropdown/Dropdown';

import './colorSelectCompact.scss';
import Label from '../../../../label/Label';

interface ColorSelectCompactProps {
    color?: string | null;
    label: string;
    onChange: (color: string | null | undefined) => void;
    menuPositionFixed?: boolean;
    hideCheckbox?: boolean;
}

function ColorSelectCompact({
    color,
    label,
    onChange,
    menuPositionFixed = false,
    hideCheckbox = false,
}: ColorSelectCompactProps): JSX.Element {
    const [isChecked, setIsChecked] = useState(!!color);
    const [colorPicker, setColorPicker] = useState<string | null | undefined>(color);

    const onChangeDebounced = useDebouncedCallback(onChange, 300);

    useEffect(() => {
        setColorPicker(color);
        setIsChecked(!!color);
    }, [color]);

    const handleCheckboxClick = (): void => {
        onChange(isChecked ? null : colorPicker);
        setIsChecked(!isChecked);
    };

    const handleColorChange = (val: string): void => {
        if (val.length > 9) return; // to prevent invalid hex colors
        setColorPicker(val);
        setIsChecked(true);
        onChangeDebounced(val);
    };

    return (
        <div className={`c-colorSelectCompact ${isChecked && !hideCheckbox ? 'c-colorSelectCompact--checked' : ''}`}>
            {!hideCheckbox && (
                <div className="c-colorSelectCompact__input" onClick={handleCheckboxClick}>
                    <Icon
                        className="c-colorSelectCompact__input_checkbox"
                        icon={isChecked ? 'solar:check-square-bold' : 'solar:stop-linear'}
                    />
                </div>
            )}
            <Dropdown
                align="left"
                modifier="c-dropdown--fit-content"
                button={
                    <div
                        className={`c-colorSelectCompact__select ${isChecked ? 'c-colorSelectCompact__select--colored' : ''}`}
                        style={{backgroundColor: isChecked ? colorPicker || 'transparent' : 'transparent'}}
                    />
                }
                menuPositionFixed={menuPositionFixed}
            >
                <HexColorPicker color={colorPicker || undefined} onChange={handleColorChange} />

                <div className="u-mt-2 u-flex u-v-center">
                    <input
                        className="e-input"
                        type="text"
                        value={colorPicker || undefined}
                        onChange={(e) => handleColorChange(e.target.value)}
                    />
                </div>
            </Dropdown>
            <Label>{label}</Label>
        </div>
    );
}

export default ColorSelectCompact;
